import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import { CREATIVE_NAMES, SIDECAR_CREATIVE_AD_FIELDS } from "./definitions";
import DropdownSection from "./DropdownSection";
import BaseCreativeControls from "./BaseCreativeControls";
import { InputSwitch } from "primereact/inputswitch";
import InputTextSection from "./InputTextSection";
const CREATIVE_TYPE = CREATIVE_NAMES.SIDECAR_CREATIVE;

const DIRECTIONALITY_OPTIONS = [
    { label: "Right-to-Left", value: "rtl" },
    { label: "Left-to-right", value: "ltr" }
]

const SWITCH_SECTION_STYLES = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5em;
    .label {
        font-weight: bold;
    }
`;

function GeneralSwitchSection({ label, isChecked, switchName, changeHandler, creativeType, children }) {
    return (
        <>
            <div css={SWITCH_SECTION_STYLES}>
                <span className="label">{label}</span>
                <InputSwitch
                    checked={isChecked}
                    name={switchName}
                    onChange={(e) => {
                        changeHandler(e, e.value, creativeType);
                    }}
                />
            </div>
            <div>{isChecked && children}</div>
        </>
    );
}

export default function SidecarCreative({
    collapsedBanner,
    expandedBanner,
    handleChange,
    impressionTag,
    currentCustomer,
    format = "banner",
    adServingType,
    clickTag,
    dir = 'rtl',
    enableInitialAnimation,
    topOffset = 0
}) {

    return (
        <>
            <BaseCreativeControls
                isClickTagRequired={true}
                adServingType={adServingType}
                changeHandler={handleChange}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
                renderClickUrlInput={true}
                clickTag={clickTag}
            >
                {
                    format === 'banner' && (
                        <DropdownSection
                            adtype={CREATIVE_TYPE}
                            label="Animation directionality"
                            name={SIDECAR_CREATIVE_AD_FIELDS.dir}
                            changeHandler={handleChange}
                            value={dir}
                            options={DIRECTIONALITY_OPTIONS}
                        />
                    )
                }

                <GeneralSwitchSection
                    label="Enable initial 'shake' animation"
                    isChecked={!!enableInitialAnimation}
                    switchName="enableInitialAnimation"
                    changeHandler={handleChange}
                    creativeType={CREATIVE_TYPE}
                />

                <AssetInputOrUploadSection
                    inputValue={collapsedBanner}
                    inputLabel="Small banner (150x250px)"
                    inputName={SIDECAR_CREATIVE_AD_FIELDS.collapsedBanner}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />

                <AssetInputOrUploadSection
                    inputValue={expandedBanner}
                    inputLabel={`Expanded banner (${format === 'banner' ? '970x250' : '300x600'})`}
                    inputName={SIDECAR_CREATIVE_AD_FIELDS.expandedBanner}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />

                <InputTextSection
                    label="Top offset (px)"
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    name={SIDECAR_CREATIVE_AD_FIELDS.topOffset}
                    value={topOffset}
                    isNumericInput={true}
                />
            </BaseCreativeControls>
        </>
    );
}
